import React, { useContext, useState } from 'react'
import { map } from 'lodash'

import PagedModal, { NavigationItem } from 'components/PagedModal'

import StoreContext from 'context/Store'

import {
  SORT_OPTIONS
} from 'constants/collection'

const SortModal = () => {
  const { collection: {
    sort: activeSort,
    setSort: setActiveSort,
    sortModalActive: active,
    setSortModalActive: setActive
  }} = useContext(StoreContext)

  const [sort, setSort] = useState(activeSort)

  const onClose = () => {
    setActive(false)
  }
  
  const onApply = () => {
    setActiveSort(sort)
    setActive(false)
  }
  
  return (
    <PagedModal
        title='Sort'
        confirmable
        confirmText='Apply'
        onConfirm={onApply}
        active={active}
        onCloseClick={onClose}>
      <>
      {map(SORT_OPTIONS, (v, k) => {
         return (
           <NavigationItem
               key={k}
               title={v}
               active={sort === k}
               onClick={() => setSort(k)}
               type='select' />    
         )
       })}
      </>
    </PagedModal>
  )
}

export default SortModal
